export default class ClassicQuizFiltersMeta {
  public classicQuizIds: string = null;
}
